import { createAction, createAsyncAction } from 'typesafe-actions';
import { AuthDto } from '../dtos/auth';
import { SessionInfoDto } from '../../features/account/login/login.dtos';

export const userLoggedIn = createAction('USER_LOGIN')<AuthDto>();
export const userLoginFail = createAction('USER_LOGIN_FAIL')<AuthDto>();
export const userXsrfToken = createAction('USER_XSRF_TOKEN')<string>();
export const tenantAction = createAction('USER_TENANT')<string>();

// Auth initialization action - calls /current-token to hydrate auth state from HttpOnly cookie
export const initializeAuthActions = createAsyncAction(
  'INITIALIZE_AUTH_REQUEST',
  'INITIALIZE_AUTH_SUCCESS',
  'INITIALIZE_AUTH_ERROR',
)<undefined, SessionInfoDto, string>();
